<div *ngIf="isOpen" class="modal fade show d-block">
  <div class="modal-dialog modal-xl">
    <div class="modal-content popup-container">
      <div class="modal-body pt-2">
        <div class="row m-0">
          <div class="col-md-11">
            <div class="row pop-up-pageTitle"> Select opportunity and opportunity services</div>
            <div class="row d-flex alignment">
              <div class="pl-0">
                <span class="selectedclientName">{{selectedReacceptanceClient.clientName}}</span>
              </div>
              <div class="circle"></div>
              <div>
                <span class="selectedclientName">{{selectedReacceptanceClient.engagementName}}</span>
              </div>
              <div class="circle"></div>
              <div>
                <span class="selectedclientName">{{selectedReacceptanceClient.solutionCode}}</span>
              </div>
            </div>
          </div>

          <div class="col-md-1 p-0">
            <button type="button" class="close edp-font-14" data-dismiss="modal" aria-hidden="true"
              (click)="onClose();">
              <span class="close-text mr-1">Close </span>
              <span class="modal-close-btn">&times;</span>
            </button>
          </div>
        </div>

        <p class="popup-description mb-2 mt-3 pt-1">
          Select the assignments for this continuance
          engagement then select the appropriate
          opportunity and opportunity service.
        </p>

        <div class="table-box mb-3 pb-2">
          <div class="col-md-12 px-0">
            <div class="main-table tableOneViewInitiate">
              <table class="table table-engage mb-0">
                <thead>
                  <tr>
                    <th class="thHeadOne">Assignments</th>
                    <th class="thHeadTwo">Opportunity</th>
                    <th class="thHeadThree">Opportunity Service</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let item of assignmentSelections; let i=index">

                    <!-- Assignment Column -->
                    <td class="thHeadOne assignment-column">
                      <div class="d-flex align-items-start">
                        <label class="custom-check edp-font-12 mb-0" [ngClass]="{'cursor-not-allowed': item.isCheckboxDisabled}">
                          <input type="checkbox" [(ngModel)]="item.isSelected" [disabled]="item.isCheckboxDisabled" (change)="onAssignmentCheckChange(item)">
                          <span class="checkmark-custom"></span>
                        </label>
                        <div class="ml-2">
                          <div class="assignment-name">{{item.assignmentName}}</div>
                          <div class="assignment-code">{{item.solutionCode}}</div>
                        </div>
                      </div>
                    </td>

                    <!-- Opportunity -->
                    <td class="thHeadTwo">
                      <div class="selectdiv">

                        <ng-container
                          *ngIf = "item.availableOpportunities.length > 0;
                                    else noOpportunity">
                                  
                        <select class="form-control dropdown rounded-0" 
                          [(ngModel)]="item.selectedOpportunityId"
                          (change)="onOpportunityChange(item)" [disabled]="!item.isSelected">
                          <option value="">Select opportunity...</option>

                          <option *ngFor="let opp of item.availableOpportunities" [value]="opp.opportunityId">
                            {{opp.opportunityName}}</option>
                        </select>
                      
                        </ng-container>
                        <ng-template #noOpportunity>
                          <select class="form-control dropdown rounded-0" disabled>
                            <option>No tracked opportunities for {{item.solutionCode}}</option>
                          </select>
                        </ng-template>

                      </div>
                    </td>

                    <!-- Opportunity Service -->
                    <td class="thHeadThree">
                      <div class="selectdiv">
                        <select class="form-control dropdown rounded-0" 
                          [(ngModel)]="item.selectedOpportunityServiceId"
                          (change)="onServiceChange(item)" [disabled]="!item.isSelected ||
                                                                       !item.selectedOpportunityId ||
                                                                       !item.availableOpportunities || 
                                                                        item.availableOpportunities.length === 0 ||
                                                                        item.availableServices.length === 0">

                         <option value="">{{ item.selectedOpportunityId 
                                                ? 'Select opportunity service...' 
                                                : 'Select an opportunity first...'}}</option>                                                  

                          <option *ngFor="let service of item.availableServices" [value]="service.opportunityServiceId">
                            {{service.solutionCode}} - {{service.opportunityServiceId}}</option>
                        </select>
                      </div>
                    </td>

                  </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>

        <div class="no-record border mt-2">
          <div class="row w-100 oneViewNoResult p-3">
            <div class="col-md-12 text-left ml-3 bgColorOpp">
              <p class="pt-2">
                If you can't find the right opportunity for the first assignment row above, it may not yet be created in
                oneView.
                Contact your engagement partner, principal or managing director for next steps.
                This note applies only to the first row, not to any other assignments.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div *ngIf="validationMessage" class="text-danger mt-2" style="margin-left: 15px;">
          <span> {{validationMessage}}</span>
        </div>

        <button type="button" class="SecondaryButton mr-2 Btn150" data-dismiss="modal" id="btnCancelOpportunityNew"
          (click)="onClose();">
          <span class="d-inline-block mr-1 align-top">
            <img alt="OK" src="../../../../assets/images/EDP/MessageDialog/cancel-blue.svg">
          </span>
          <span class="d-inline-block align-middle">Cancel</span>
        </button>
        <button type="button" class="PrimaryButton Btn150" id="btnOkOpportunityNew" (click)="onConfirm();">
          <span class="d-inline-block mr-1 align-top">
            <img alt="OK" src="../../../../assets/images/EDP/MessageDialog/delete-white.svg">
          </span>
          <span class="d-inline-block align-middle">OK</span>
        </button>
      </div>

    </div>

  </div>
</div>
<div *ngIf="isOpen" class="modal-backdrop fade show"></div>